import { DIContainer } from './container';

export const mainContainer = new DIContainer();
